"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var formik_1 = require("formik");

var react_1 = __importDefault(require("react"));

var components_1 = require("../../components");

var enums_1 = require("../../enums");

var styled_1 = require("../styled");

var FormikConnected_1 = __importDefault(require("./FormikConnected"));

var PersonalDetailsInputs =
/** @class */
function (_super) {
  __extends(PersonalDetailsInputs, _super);

  function PersonalDetailsInputs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onDobChangeHandler = function (value) {
      var _a = _this.props,
          setFieldTouched = _a.setFieldTouched,
          setFieldValue = _a.setFieldValue,
          touched = _a.touched;
      var dateOfBirthName = enums_1.FieldNames.dateOfBirth;
      setFieldValue(dateOfBirthName, value); // tslint:disable-next-line: no-unused-expression

      !touched[dateOfBirthName] && setFieldTouched(dateOfBirthName, true);
    };

    _this.onDobEnterKeyHandler = function () {
      var _a = _this.props,
          handleSubmit = _a.handleSubmit,
          setFieldTouched = _a.setFieldTouched,
          values = _a.values,
          isValid = _a.isValid;
      var dateOfBirthName = enums_1.FieldNames.dateOfBirth;

      if (values[dateOfBirthName] && isValid) {
        handleSubmit();
      } else {
        setFieldTouched(dateOfBirthName);
      }
    };

    return _this;
  }

  PersonalDetailsInputs.prototype.render = function () {
    var _a = this.props,
        previousHandler = _a.previousHandler,
        activeBreakpoint = _a.activeBreakpoint,
        updating = _a.updating,
        handleSubmit = _a.handleSubmit,
        isValid = _a.isValid,
        DateInputComponent = _a.DateInputComponent,
        isSubmitting = _a.isSubmitting,
        values = _a.values;
    var buttonProps = {
      type: components_lib_1.ButtonTypeEnum.primary,
      text: enums_1.FieldPlaceHolders.signUp,
      onPress: handleSubmit,
      disabled: !isValid || updating
    };

    if (updating) {
      buttonProps.icon = {
        position: components_lib_1.ButtonIconPositionEnum.left,
        name: '',
        size: components_lib_1.IconSizeEnum.small,
        renderFunction: function renderFunction() {
          return react_1.default.createElement(components_lib_1.LoadingIndicator, {
            size: "small"
          });
        }
      };
    }

    return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(FormikConnected_1.default, {
      formik: __assign({}, this.props)
    }), react_1.default.createElement(components_1.FormInputGroup, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
      placeholder: enums_1.FieldPlaceHolders.firstName,
      name: enums_1.FieldNames.firstName
    }, this.props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
      placeholder: enums_1.FieldPlaceHolders.lastName,
      name: enums_1.FieldNames.lastName
    }, this.props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
      placeholder: enums_1.FieldPlaceHolders.nickName,
      name: enums_1.FieldNames.nickName,
      label: enums_1.FieldLabels.nickName,
      accessibilityLabel: "Enter your nickname"
    }, this.props)), react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, this.props, {
      name: enums_1.FieldNames.dateOfBirth
    }), react_1.default.createElement(components_lib_1.StyledInputLabel, null, enums_1.FieldLabels.dateOfBirth), react_1.default.createElement(formik_1.Field, {
      component: DateInputComponent,
      name: enums_1.FieldNames.dateOfBirth,
      label: enums_1.FieldLabels.dateOfBirth,
      value: this.props.values.dateOfBirth,
      onChange: this.onDobChangeHandler,
      onEnterKeyPress: this.onDobEnterKeyHandler,
      disabled: isSubmitting,
      placeholder: enums_1.FieldPlaceHolders.dateOfBirth,
      activeBreakpoint: activeBreakpoint,
      accessibilityLabel: "Date of Birth"
    }))), react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, this.props, {
      name: enums_1.FieldNames.preferredPronoun
    }), react_1.default.createElement(formik_1.Field, {
      component: components_lib_1.FormPicker,
      name: enums_1.FieldNames.preferredPronoun,
      label: enums_1.FieldLabels.preferredPronoun,
      type: components_lib_1.FormPickerComponent.type.singleSelect,
      options: core_1.preferredPronounValues,
      disabled: isSubmitting,
      accessibilityLabel: "Preferred Pronoun"
    }))), react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, this.props, {
      name: enums_1.FieldNames.country
    }), react_1.default.createElement(formik_1.Field, {
      component: components_lib_1.FormPicker,
      name: enums_1.FieldNames.country,
      label: enums_1.FieldLabels.country,
      type: components_lib_1.FormPickerComponent.type.singleSelect,
      options: core_1.countryValues,
      accessibilityLabel: "Country",
      disabled: isSubmitting
    }))), values.country === core_1.usaFormFieldValue && react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
      name: enums_1.FieldNames.zipCode,
      label: enums_1.FieldLabels.zipCode,
      isSecure: false,
      isDisabled: isSubmitting,
      accessibilityLabel: "Zip Code"
    }, this.props)))), react_1.default.createElement(styled_1.AuthButtonsContainer, null, react_1.default.createElement(styled_1.StepButtonsWrapper, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(components_lib_1.Button, {
      type: components_lib_1.ButtonTypeEnum.link,
      text: enums_1.FieldLabels.back,
      uppercase: true,
      onPress: previousHandler,
      accessibilityLabel: enums_1.FieldLabels.back
    }), react_1.default.createElement(components_lib_1.Button, __assign({}, buttonProps, {
      uppercase: true,
      accessibilityLabel: "Continue"
    })))));
  };

  return PersonalDetailsInputs;
}(react_1.default.Component);

exports.PersonalDetailsInputs = PersonalDetailsInputs;